<template>
  <RouterLink v-if="to" v-slot="attrs" :to="to">
    <slot :="attrs"></slot>
  </RouterLink>
  <component :is="or" v-else>
    <slot :="{ isActive: false, isExactActive: false }"></slot>
  </component>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'

defineProps<
  Partial<{ or: keyof HTMLElementTagNameMap; to: RouteLocationRaw }>
>()
</script>
